// GENERATED by bam-api-services/scripts/sync-tenants.js — DO NOT EDIT.
// Source of truth: bam-api-services/src/constants/tenants.json

/**
 * Admin host -> tenant key, for hosts whose subdomain is NOT the tenant key.
 * ssoHandoff's fallback regex yields the subdomain, so without an entry the
 * cross-domain handoff compares the wrong key against the token and fails
 * closed. Only rebrands and renames appear here.
 */
export const ADMIN_HOST_TENANT_KEY = {
  "admin-arrowheadwinch.bam.zone": "paccarwinch",
  "admin-btahelp.bam.zone": "bta",
  "admin-labot.bam.zone": "ycrobotech",
  "admin-promach.bam.zone": "promachbuilt",
  "admin-viably.bam.zone": "kta"
}

/**
 * Tenant key -> the tenant's own mp web portal, for the header's "App" button.
 * The key comes from the signed-in user's `custom:tenant` claim, not from the
 * host, so the button also works on the tenant-agnostic admin.bam.zone.
 *
 * A tenant missing here has no domain of its own (sharedHosts) or is not on the
 * app stage; appUrl() falls back to the stage's shared front door.
 */
export const APP_URL_BY_TENANT = {
  abs: "https://abs.bam.zone",
  anaconda: "https://anaconda.bam.zone",
  avanttecno: "https://avanttecno.bam.zone",
  bta: "https://btahelp.bam.zone",
  develon: "https://develon.bam.zone",
  diefenbach: "https://diefenbach.bam.zone",
  eagle: "https://eagle.bam.zone",
  eagleironworks: "https://eagleironworks.bam.zone",
  fennerdunlop: "https://fennerdunlop.bam.zone",
  finn: "https://finn.bam.zone",
  frain: "https://frain.bam.zone",
  gefran: "https://gefran.bam.zone",
  hcea: "https://hcea.bam.zone",
  jls: "https://jls.bam.zone",
  kta: "https://viably.bam.zone",
  mclanahan: "https://mclanahan.bam.zone",
  paccarwinch: "https://arrowheadwinch.bam.zone",
  popart: "https://popart.bam.zone",
  promachbuilt: "https://promach.bam.zone",
  rubblecrusher: "https://rubblecrusher.bam.zone",
  sato: "https://sato.bam.zone",
  showme: "https://showme.bam.zone",
  titan: "https://titan.bam.zone",
  ycrobotech: "https://labot.bam.zone"
}
